import { render, staticRenderFns } from "./Mapa.vue?vue&type=template&id=bc4444f0&scoped=true"
import script from "./Mapa.vue?vue&type=script&lang=ts"
export * from "./Mapa.vue?vue&type=script&lang=ts"
import style0 from "./Mapa.vue?vue&type=style&index=0&id=bc4444f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4444f0",
  null
  
)

export default component.exports